import { styled, Accordion } from '@mui/material';

export const CustomAccordion = styled(Accordion)<{ isfirst: boolean }>(({ isfirst }) => ({
	borderBottom: '1px solid rgba(0, 0, 0, .125)',
	borderTop: isfirst ? '1px solid #E2E2E2' : 'none',
}));
